import { useQuery } from 'react-query';

import { USE_INFOR_USER } from 'constants/Auth';
import { getInforUser } from '../api/auth';
import cookieFC from '../helpers/cookie';
import configs from 'config';

export function useInforAuth() {
  const { data, isLoading, error } = useQuery(USE_INFOR_USER, async () => {
    if(!cookieFC.getToken()){
      window.location.href = configs.API_DOMAIN_LOGIN;
      return;
    }
    const response = await getInforUser();

    return response?.data;
  });

  return { ...data, isLoading, error };
}

// Chỉ hiện mục ACMS BOM khi BOM trả lời có quyền; lỗi hoặc chưa trả lời thì ẩn (bom-task, đặc tả 006).
export function useBomAccess() {
  const { data } = useQuery(
    'USE_BOM_ACCESS',
    async () => {
      const response = await fetch(`${configs.DOMAIN_AMS_BOM}/api/access/me`, { credentials: 'include' });
      return response.json();
    },
    { retry: false, refetchOnWindowFocus: false, staleTime: 5 * 60 * 1000 },
  );

  return data?.allowed === true;
}
